import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Sized for a chat panel rather than an article page.
const chatMarkdownComponents = {
  h1: ({ children }) => <h3 className="mt-4 mb-1.5 font-semibold first:mt-0">{children}</h3>,
  h2: ({ children }) => <h3 className="mt-4 mb-1.5 font-semibold first:mt-0">{children}</h3>,
  h3: ({ children }) => <h4 className="mt-3 mb-1 font-semibold first:mt-0">{children}</h4>,
  h4: ({ children }) => <h4 className="mt-3 mb-1 font-semibold first:mt-0">{children}</h4>,
  p: ({ children }) => <p className="my-2 leading-6 first:mt-0 last:mb-0">{children}</p>,
  ul: ({ children }) => <ul className="my-2 list-disc space-y-1 pl-5 leading-6">{children}</ul>,
  ol: ({ children }) => <ol className="my-2 list-decimal space-y-1 pl-5 leading-6">{children}</ol>,
  li: ({ children }) => <li className="pl-0.5">{children}</li>,
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
  blockquote: ({ children }) => <blockquote className="border-secondary my-3 border-l-4 pl-3">{children}</blockquote>,
  hr: () => <hr className="my-4" />,
  table: ({ children }) => (
    <div className="my-3 overflow-x-auto rounded-md border">
      <table className="w-full text-xs">{children}</table>
    </div>
  ),
  thead: ({ children }) => <thead className="bg-muted/50 border-b">{children}</thead>,
  th: ({ children }) => <th className="px-2 py-1.5 text-left font-semibold">{children}</th>,
  td: ({ children }) => <td className="border-t px-2 py-1.5">{children}</td>,
  code: ({ children }) => <code className="bg-muted rounded px-1 py-0.5 font-mono text-[0.85em]">{children}</code>,
  pre: ({ children }) => <pre className="bg-muted my-3 overflow-x-auto rounded-md border p-3">{children}</pre>
};

/**
 * An assistant's reply as GitHub-flavoured Markdown, styled for a chat panel.
 * `components` overrides single elements (a link, a test id on a list); every
 * other prop goes to react-markdown (`urlTransform`, `disallowedElements`).
 */
function ChatMarkdown({ markdown, components, ...props }) {
  return (
    <ReactMarkdown components={{ ...chatMarkdownComponents, ...components }} remarkPlugins={[remarkGfm]} {...props}>
      {markdown}
    </ReactMarkdown>
  );
}

export { ChatMarkdown };
